import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import SidebarColumn from '../../modules/SidebarColumn';
import PageSidebar from '../../modules/PageSidebar';
import ContentColumn from '../../modules/ContentColumn';
import PageSection from '../../modules/PageSection';
import Page from '../../pages/Page';
import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';

import * as licenceActions from '../../../actions/userLicences';
import licenceKeyNames from '../../../services/ui/licenceKeyNames';

import styles from './styles.scss';

class AdminUserLicences extends React.Component {

    componentDidMount() {
        this.props.resetLicences();
        this.props.refreshLicences(this.props.match.params.id);
    }

    render() {

        return (
            <Page>
                <PageMeta title="Signed Licences" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageSection>

                        <AlertMessage>
                            {this.props.isInitialised && this.props.licences.length === 0 &&
                                <AlertBox theme="warning">This user has not signed any licences yet.</AlertBox>
                            }
                        </AlertMessage>

                        {this.props.licences.length > 0 &&
                            <table className={styles['licences-table']}>
                                <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Signed Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.props.licences.map((signedLicence, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>
                                                <Link className={styles['service-licence']} to={`/licences/${signedLicence.licence_id}`}>
                                                    { signedLicence.service.name } ({ licenceKeyNames[signedLicence.licence_type] })
                                                </Link>
                                                <div>
                                                    <Link className={styles['licence-name']} to={`/licences/${signedLicence.licence_id}`}>
                                                        { signedLicence.licence.name }
                                                    </Link>
                                                </div>
                                            </td>
                                            <td>{ moment.utc(signedLicence.created_at).local().format('Do MMMM YYYY') }</td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        }

                    </PageSection>
                </ContentColumn>
            </Page>
        )
    }
}

function mapStateToProps(state) {
    return {
        licences: state.userLicences.licences,
        isInitialised: state.userLicences.isInitialised
    }
}

function mapDispatchToProps(dispatch) {
    return {
        resetLicences() {
            dispatch(licenceActions.resetUserLicences());
        },
        refreshLicences(userId) {
            dispatch(licenceActions.refreshUserLicences(userId));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserLicences);